import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("La contraseña debe tener al menos 8 caracteres.");
    if (pw !== pw2) return setError("Las contraseñas no coinciden.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50 dark:bg-[#0B0F17]">
      <Card className="w-full max-w-md" data-testid="reset-password-card">
        <CardHeader><CardTitle className="text-2xl">Nueva contraseña</CardTitle></CardHeader>
        <CardContent>
          {done ? (
            <div className="space-y-4">
              <p data-testid="reset-password-success" className="text-sm text-emerald-700">
                Contraseña cambiada. Ya puedes iniciar sesión con la nueva.
              </p>
              <Link to="/login" data-testid="reset-go-login" className="text-[#026FCB] hover:underline text-sm">Ir a iniciar sesión</Link>
            </div>
          ) : !token ? (
            <p data-testid="reset-password-missing-token" className="text-sm text-red-600">
              Falta el enlace de restablecimiento. Pide uno nuevo desde la pantalla de inicio de sesión.
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="np">Nueva contraseña</Label>
                <Input id="np" type="password" autoComplete="new-password" required data-testid="reset-new-password" value={pw} onChange={(e) => setPw(e.target.value)} />
              </div>
              <div>
                <Label htmlFor="np2">Repite la contraseña</Label>
                <Input id="np2" type="password" autoComplete="new-password" required data-testid="reset-confirm-password" value={pw2} onChange={(e) => setPw2(e.target.value)} />
              </div>
              {error && <div data-testid="reset-password-error" className="text-sm text-red-600">{error}</div>}
              <Button type="submit" data-testid="reset-password-submit" className="w-full bg-[#026FCB] hover:bg-[#0358a5]" disabled={loading}>
                {loading ? "Guardando..." : "Guardar contraseña"}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
